// extracted by mini-css-extract-plugin
export default {"root":"_17HfU","viewport":"wV0UJ","swipeable":"_2UlBm","panel":"_1zJQG","pagination":"YG1oC"};